// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"827":"492f1c69","3623":"06b03958","3900":"93d3881d","8307":"f740a5fb"}[chunkId] + ".css";
};